import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import { useCallback } from "react";

const ParticlesBackground = ({ darkMode }) => {

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={{
        fullScreen: { enable: true, zIndex: -1 },
        particles: {
          number: { value: 30 },
          color: { value: darkMode ? "#ffffff" : "#030303" },
          shape: { type: "square" },
          opacity: { value: 0.5 },
          size: { value: 3 },
          move: { enable: true, speed: 1 },
          links: {
            enable: false,
            distance: 150,
            color: darkMode ? "#ffffff" : "#030303",
            opacity: 0.4,
            width: 1,
          },
        },
      }}
    />
  );
}


export default ParticlesBackground